import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Book3D } from './ui/Book3D';
import { CtaButton } from './ui/CtaButton';
import { heroBenefits } from '../data/content';
const sideCovers = [{
  src: 'https://cdn.magicpatterns.com/uploads/jcsbsTPVsBppeWjEC7SSUy/rutas_recomendadas.png',
  alt: 'Portada de Rutas Recomendadas',
  className: 'left-0 bottom-6 w-[26%] max-w-[110px] -rotate-6'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sLEukxdt7EngCuwvDmBu4Q/Planner_de_Viaje_editable.png',
  alt: 'Portada del Planner de Viaje Editable',
  className: 'right-0 bottom-10 w-[26%] max-w-[110px] rotate-6'
}];
export function Hero() {
  return <section className="w-full bg-polar pt-14 sm:pt-20" data-id="element-58" data-mp="s9ghk1uwwk98">
      <div className="mx-auto w-full max-w-content px-5 pb-14 pt-8 text-center sm:px-8 sm:pb-16 sm:pt-12" data-id="element-59" data-mp="nczt16jsw3vm">
        <p className="font-sans text-[10px] font-medium uppercase tracking-[0.26em] text-caribe sm:text-[11px]" data-id="element-60" data-mp="3d2labedjz91r">
          Europa por primera vez
        </p>

        <h1 className="mx-auto mt-4 max-w-[20ch] font-display text-[32px] font-bold leading-[1.1] text-oceano sm:max-w-[24ch] sm:text-[46px] lg:text-[52px]" data-id="element-61" data-mp="3j8ixl0k6uiv8">
          Organizá tu primer viaje a{' '}
          <em className="not-italic text-caribe" data-id="element-62" data-mp="39acw2k2aneqw">Europa por tu cuenta</em>, sin depender de una agencia
        </h1>

        <p className="mx-auto mt-5 max-w-[52ch] font-sans text-[13.5px] leading-relaxed text-hierro sm:text-[15px]" data-id="element-63" data-mp="3e8wkqs89v4my">
          Una guía práctica con rutas, herramientas y plantillas para ayudarte a organizar tu
          itinerario, calcular tus gastos, encontrar mejores opciones y llegar al viaje con todo mucho
          más claro.
        </p>

        <div className="relative mx-auto mt-9 max-w-[420px] sm:mt-12" data-id="element-64" data-mp="2qlog8cio3zlz">
          {sideCovers.map(cover => <img key={cover.src} src={cover.src} alt={cover.alt} className={`absolute z-0 hidden rounded-[2px] shadow-[0_20px_30px_-20px_rgba(27,51,64,0.5)] sm:block ${cover.className}`} data-id="element-65" data-mp="2vjga3c2vhvst" />)}
          <Book3D className="relative z-10 mx-auto w-[64%] max-w-[240px] sm:w-[58%] sm:max-w-[250px]" data-id="element-66" data-mp="2ljh0rcymq1ew" />
        </div>

        <ul className="mx-auto mt-10 grid max-w-[30rem] grid-cols-1 gap-2 text-left" data-id="element-67" data-mp="s3cm2bn71lr3">
          {heroBenefits.map(benefit => <li key={benefit} className="flex items-center gap-3 rounded-lg border border-oceano/10 bg-white px-4 py-3" data-id="element-68" data-mp="n9i2r9bi38sj">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-caribe" strokeWidth={3} aria-hidden="true" data-id="element-69" data-mp="ddf44dfuxsac" />
              <span className="font-sans text-[13px] leading-snug text-oceano/85 sm:text-[13.5px]" data-id="element-70" data-mp="1b1fe6zb1fyt4">
                {benefit}
              </span>
            </li>)}
        </ul>

        <div className="mt-9" data-id="element-71" data-mp="112px38qyuidx">
          <CtaButton size="lg" className="sm:min-w-[380px]" data-id="element-72" data-mp="111yauoj9dx0b">
            Quiero organizar mi viaje
          </CtaButton>
          <p className="mt-3.5 font-sans text-[11.5px] tracking-[0.05em] text-hierro" data-id="element-73" data-mp="x0crqlg4smho">
            Producto 100% digital · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}